<template>
    <div id="wrapper" >
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.collect')}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">

                                <div class="form-row mb-4">
                                    <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                            {{$t('string.msg.connect.truck.register.trucker')}}
                                        </label>
                                        <multiselect v-model="data.trucker" :options="truckers" @input="selectItem(data.trucker)" 
                                            :close-on-select="true" track-by="_id" :custom-label="customLabelTrucker" :searchable="true"
                                            placeholder="Selecione" > 
                                        </multiselect>  
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.age')}}
                                        </label>
                                        <input type="text" v-model="data.age" class="form-control" v-mask="['##']" :placeholder="$t('string.msg.health.age')">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.heartRate')}}
                                        </label>
                                        <input type="text" v-model="data.heartRate" class="form-control" v-mask="['###']" :placeholder="$t('string.msg.health.heartRate')" >
                                    </div>
                                </div>


                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.systolicPressure')}}
                                        </label>
                                        <input type="text" v-model="data.systolicPressure" class="form-control" v-mask="['###']" :placeholder="$t('string.msg.health.systolicPressure')">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.diastolicPressure')}}
                                        </label>
                                        <input type="text" v-model="data.diastolicPressure" class="form-control" :placeholder="$t('string.msg.health.diastolicPressure')" v-mask="['###']">
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.abdominalWaist')}}
                                        </label>
                                        <input type="text" v-model="data.abdominalWaist" class="form-control" v-mask="['###']" :placeholder="$t('string.msg.health.abdominalWaist')">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.temperature')}}
                                        </label>
                                        <input type="text" v-model="data.temperature" class="form-control" :placeholder="$t('string.msg.health.temperature')" v-mask="['##.#']">
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.saturation')}}
                                        </label>
                                        <input type="text" v-model="data.saturation" class="form-control" v-mask="['###']" :placeholder="$t('string.msg.health.saturation')">
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputAddress" class="col-form-label">
                                        {{$t('string.msg.health.diabets')}}
                                    </label>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="true" :value="true" v-model="data.diabetes" class="custom-control-input">
                                        <label class="custom-control-label" for="true">{{$t('str.msg.yes')}}</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="false" :value="false" v-model="data.diabetes" class="custom-control-input">
                                        <label class="custom-control-label" for="false">{{$t('str.msg.no')}}</label>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.bloodGlucose')}}
                                        </label>
                                        <input type="text" v-model="data.bloodGlucose" class="form-control" :placeholder="$t('string.msg.health.bloodGlucose')" v-mask="['###']">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label">
                                            {{$t('string.msg.health.obs')}}
                                        </label>
                                        <textarea style="height:100px;" type="text" v-model="data.obs" class="form-control" :placeholder="$t('string.msg.health.obs')"></textarea>              
                                    </div>
                                </div>
                                <button type="button" class="mt-2 mb-2 btn btn-danger w-20" v-on:click="save">{{$t('string.msg.save')}}</button>

                                <div v-if="errors.length" class="alert alert-danger">
                                    <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                    <ul>
                                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                    </ul>
                                </div>

                                <div v-if="items && items.length > 0">
                                    <div class="form-group col-md-12 text-right" >
                                        <h4>{{$t('str.total')}}</h4>
                                        <h4>{{items.length}}</h4>
                                    </div>
                                    <div class="form-row align-items-end" v-if="items && items.length > 0">
                                        <div class="form-group col-md-6" >
                                            <download-excel
                                                class = "btn btn-primary"
                                                :fetch = "fetchData"
                                                :fields = "json_fields"
                                                type = "csv"
                                                name = "coleta.csv">
                                                Download CSV
                                            </download-excel>
                                        </div>
                                    </div>


                                    <div class="pb-0 pt-3 ">
                                        <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-centered table-hover mb-0" id="datatable">
                                            <thead>
                                                <tr>
                                                    <th class="border-top-0" style="width:12%">{{$t('string.msg.health.trucker')}}</th>
                                                    <th class="border-top-0" style="width:8%">{{$t('string.msg.health.data')}}</th>
                                                     <th class="border-top-0" style="width:5%">{{$t('string.msg.health.age')}}</th>
                                                      <th class="border-top-0" style="width:5%">{{$t('string.msg.health.heartRate')}}</th>
                                                    <th class="border-top-0" style="width:8%">{{$t('string.msg.health.systolicPressure')}}</th>
                                                    <th class="border-top-0" style="width:8%">{{$t('string.msg.health.diastolicPressure')}}</th>
                                                    <th class="border-top-0" style="width:9%">{{$t('string.msg.health.abdominalWaist')}}</th>
                                                    <th class="border-top-0" style="width:5%">{{$t('string.msg.health.temperature')}}</th>
                                                    <th class="border-top-0" style="width:5%">{{$t('string.msg.health.saturation')}}</th>
                                                    <th class="border-top-0" style="width:5%">{{$t('string.msg.health.diabets')}}</th>
                                                    <th class="border-top-0" style="width:5%">{{$t('string.msg.health.bloodGlucose')}}</th>
                                                    <th class="border-top-0" style="width:25%">{{$t('string.msg.health.obs')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer">
                                                <tr v-if="item.status == 'ACTIVE'">
                                                     <td>
                                                        <span v-if="item.trucker">
                                                            {{item.trucker.firstName ? camelize(item.trucker.firstName) : ''}}
                                                            {{ item.trucker.lastName ? camelize(item.trucker.lastName) : ''}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.date">
                                                            {{new Date(item.date).toLocaleDateString()}} - {{new Date(item.date).toLocaleTimeString()}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.age">
                                                            {{item.age}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.heartRate">
                                                            {{item.heartRate}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.systolicPressure">
                                                            {{item.systolicPressure}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.diastolicPressure">
                                                            {{item.diastolicPressure}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.abdominalWaist">
                                                            {{item.abdominalWaist}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.temperature">
                                                            {{item.temperature}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.saturation">
                                                            {{item.saturation}}
                                                        </span>
                                                    </td>
                                                     <td>
                                                        <span v-if="item.diabetes">
                                                            {{item.diabetes == true ? $t('str.msg.yes') : $t('str.msg.no')}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.bloodGlucose">
                                                            {{item.bloodGlucose}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span v-if="item.obs">
                                                            {{item.obs}}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Controller from './CrtHealth';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Health',
  props: ["valuekey"],
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        pageOfItems: [],
        truckers: [],
        data: {
            date: new Date(),
            trucker: null,
            age: null,
            heartRate: null,
            systolicPressure: null,
            diastolicPressure: null,
            abdominalWaist: null,
            temperature: null,
            saturation: null,
            diabetes: false,
            bloodGlucose: null,
            obs: null,
            status: "ACTIVE"
        },
        json_fields: {
            'Nome': 'trucker.firstName',
            'Sobrenome': 'trucker.lastName',
            'Data da Coleta': 'date',
            'Idade': 'age',
            'Frequencia Cardiaca': 'heartRate',
            'Pressão Sistólica': 'systolicPressure',
            'Pressão Diastólica': 'diastolicPressure',
            'Cintura Abdominal': 'abdominalWaist',
            'Temperatura': 'temperature',
            'Saturaçao': 'saturation',
            'Diabetes': 'diabetes',
            'Glicemia': 'bloodGlucose',
            'Observações': 'obs'
        },
        json_data: [
            {
                firstName: null,
                lastName: null,
                date: null,
                age: null,
                heartRate: null,
                systolicPressure: null,
                diastolicPressure: null,
                abdominalWaist: null,
                temperature: null,
                saturation: null,
                diabetes: false,
                bloodGlucose: null,
                obs: null,
            }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
    }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    
  },
  mounted(){
    }
  }

</script>

<style>
.multiselect__option--highlight {
    background: #343B4A;
    outline: none;
    color: #fff;
}
.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #343B4A;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #343B4A;
}
</style>
